import { formatDateRu } from "../../../utils/appointmentLabels";
import s from "../clinic.module.css";
import { Button, Field, Input } from "../../ui";

function medStatus(expiresAt) {
  if (!expiresAt) {
    return { tone: "muted", icon: "○", label: "Не задан", hint: "Укажите срок допуска" };
  }
  const d = new Date(expiresAt);
  if (Number.isNaN(d.getTime())) {
    return { tone: "muted", icon: "○", label: "Не задан", hint: null };
  }
  const days = Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  const dateLabel = formatDateRu(`${String(expiresAt).slice(0, 10)}T12:00:00`, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  if (days < 0) {
    return {
      tone: "danger",
      icon: "●",
      label: "Просрочена",
      hint: `Истекла ${dateLabel}`,
    };
  }
  if (days <= 14) {
    return {
      tone: "warn",
      icon: "●",
      label: "Истекает скоро",
      hint: `Действует до ${dateLabel} (${days} дн.)`,
    };
  }
  return {
    tone: "ok",
    icon: "●",
    label: "Действительна",
    hint: `До ${dateLabel}`,
  };
}

export default function ClientMedicalSection({
  edit,
  setEdit,
  onSave,
  editing,
  onToggleEdit,
  embedded = false,
  inFold = false,
}) {
  const status = medStatus(edit.medical_clearance_expires_at);
  const fileUrl = edit.medical_clearance_file_url?.trim();

  const content = (
    <>
      {!inFold ? (
        <div className={embedded ? s.clientProfileEmbeddedHead : s.clientProfileSectionHead}>
          {embedded ? (
            <h3 className={s.clientTabCardTitle}>Допуск к занятиям</h3>
          ) : (
            <h2 className={s.clientProfileSectionTitle}>Допуск к занятиям</h2>
          )}
          <button type="button" className={s.clientProfileSectionAction} onClick={onToggleEdit}>
            {editing ? "Готово" : "Обновить"}
          </button>
        </div>
      ) : null}

      <div className={s.clientMedStatusRow}>
        <span
          className={`${s.clientMedStatusIcon} ${s[`clientMedStatusIcon_${status.tone}`]}`}
          aria-hidden
        >
          {status.icon}
        </span>
        <div>
          <strong>{status.label}</strong>
          {status.hint ? <p className={s.clientTabMuted}>{status.hint}</p> : null}
        </div>
      </div>

      {edit.allergies?.trim() ? (
        <p className={s.clientMedAllergy}>
          <strong>Особые отметки:</strong> {edit.allergies}
        </p>
      ) : null}

      {fileUrl ? (
        <a
          href={fileUrl}
          target="_blank"
          rel="noreferrer"
          className={s.clientMedFileLink}
        >
          {fileUrl.match(/\.(jpg|jpeg|png|webp|gif)/i) ? (
            <img src={fileUrl} alt="Допуск" className={s.clientMedThumb} />
          ) : (
            <span>Открыть файл справки</span>
          )}
        </a>
      ) : null}

      {editing ? (
        <form
          className={s.clientTabFormStack}
          onSubmit={(e) => {
            e.preventDefault();
            onSave(e);
            onToggleEdit();
          }}
        >
          <Field label="Справка действует до">
            <Input
              type="date"
              value={edit.medical_clearance_expires_at || ""}
              onChange={(e) =>
                setEdit({ ...edit, medical_clearance_expires_at: e.target.value })
              }
            />
          </Field>
          <Field label="Ссылка на скан">
            <Input
              value={edit.medical_clearance_file_url || ""}
              onChange={(e) =>
                setEdit({ ...edit, medical_clearance_file_url: e.target.value })
              }
              placeholder="https://…"
            />
          </Field>
            <Field label="Особые отметки">
            <Input
              value={edit.allergies || ""}
              onChange={(e) => setEdit({ ...edit, allergies: e.target.value })}
            />
          </Field>
          <Button type="submit" size="sm">
            Сохранить
          </Button>
        </form>
      ) : null}
    </>
  );

  if (embedded) {
    return <div className={s.clientProfileEmbeddedBlock}>{content}</div>;
  }

  return (
    <section id="client-medicine" className={s.clientProfileSection}>
      {content}
    </section>
  );
}
